import React, { useState, useEffect } from 'react';
import axios from 'axios';

// import history from '../../../../commons/history';
import { LANDINGPAGE } from '../../../../commons/api';

import AllModules from './AllModulesList';
import TrainStatus from './TrainStatus';
import CentralDashboard from './CentralDashboard';
// import CMRLFaults from './CMRL_Faults';
// import TurbineHomePage from './TurbineHomePage';
import EquipmentOverview from './EquipmentOverview';
import { useLocation } from 'react-router-dom';

const COMPONENT_MAP = {
  TrainStatus: (props) => <TrainStatus navigate={props.navigate} />,
  AllModules: () => <AllModules />,
  CentralDashboard: () => <CentralDashboard />,
  // CMRLFaults: () => <CMRLFaults />,
  // TurbineHomepage: () => <TurbineHomePage />,
  EquipmentOverview: () => <EquipmentOverview />,
};

const DefaultLandingPageComponent = (props) => {
  const [landingPageList, setLandingPageList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getLandingPageList = async () => {
      try {
        let siteId = window.localStorage.getItem('currentSite') || 5;
        let accessToken = window.localStorage.getItem('accessToken');

        let orgHeaders = {
          method: 'GET',
          url: `${LANDINGPAGE.GET}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        };
        const response = await axios(orgHeaders);
        setLandingPageList(response.data);
      } catch (error) {
        if (error.response) {
          console.error("API Error:", error.response.data, error.response.status);
        } else if (error.request) {
          console.error("No response received:", error.request);
        } else {
          console.error("Error", error.message);
        }
      } finally {
        setLoading(false);
      }
    };

    getLandingPageList();
  }, []);

  // let searchParams = new URLSearchParams(history.location.search);
   const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let landingPageName = searchParams.get('name');

  // Try to match by name from route, then by ID from props
  let matchedLandingPage = null;
  if (landingPageName) {
    matchedLandingPage = landingPageList.find(
      (item) => item.Name === landingPageName
    );
  } else if (props.landingPage) {
    matchedLandingPage = landingPageList.find(
      (item) => String(item.Id) === String(props.landingPage)
    );
  }

  // If loading, show loading
  if (loading) {
    return <div>Loading...</div>;
  }

  // If route name matches a special component, render it
  if (landingPageName && COMPONENT_MAP[landingPageName]) {
    return COMPONENT_MAP[landingPageName](props);
  }

  // If matched landing page, try to render its mapped component
  if (matchedLandingPage && COMPONENT_MAP[matchedLandingPage.Name]) {
    return COMPONENT_MAP[matchedLandingPage.Name](props);
  }

  // ---- NEW LOGIC: If no match, try to navigate by path using landingPage ID ----
  if (props.landingPage) {
    const fallbackPage = landingPageList.find(
      (item) => String(item.Id) === String(props.landingPage)
    );
    if (fallbackPage && fallbackPage.Path) {
      // Prevent navigation loop: only navigate if not already at the path
      if (location.pathname !== fallbackPage.Path) {
        setTimeout(() => {
          props.navigate(fallbackPage.Path);
        }, 0);
        return <div>Navigating to your landing page...</div>;
      }
    }
  }

  // Fallback
  return <div></div>;
};

export default DefaultLandingPageComponent;
